// components/agentCommands.ts
import { DESIGN_COMMAND_DEFINITIONS, designCommandTimeEstimations } from './designCommands';
import { DEALER_COMMAND_DEFINITIONS, dealerCommandTimeEstimations } from './dealerCommands';
import { SLIDES_COMMAND_DEFINITIONS, slidesCommandTimeEstimations } from './slidesCommands';
import { PULSE_COMMAND_DEFINITIONS, pulseCommandTimeEstimations } from './footfall/pulseCommands';

export const COMMAND_DEFINITIONS = {
  ...DESIGN_COMMAND_DEFINITIONS,
  ...DEALER_COMMAND_DEFINITIONS,
  ...SLIDES_COMMAND_DEFINITIONS,
  ...PULSE_COMMAND_DEFINITIONS,
};

export const commandTimeEstimations = {
  ...designCommandTimeEstimations,
  ...dealerCommandTimeEstimations,
  ...slidesCommandTimeEstimations,
  ...pulseCommandTimeEstimations,
};
